module.exports = {"232762100":"小扬气镇","232762101":"劲松镇","232762102":"古源镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/232762.json
// module id = 806
// module chunks = 0